import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ArrowUpRight } from "lucide-react";
import { getAnnouncement } from "../lib/api";
import { EASE } from "./Reveal";

const STORAGE_KEY = "el_announce_dismissed";

const hashOf = (a) => btoa(unescape(encodeURIComponent(a.title + "|" + a.message)));

export default function AnnouncementPopup() {
  const [ann, setAnn] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    getAnnouncement()
      .then((a) => {
        if (!a || !a.enabled || !a.message) return;
        if (localStorage.getItem(STORAGE_KEY) === hashOf(a)) return;
        setAnn(a);
        setTimeout(() => setOpen(true), 2200);
      })
      .catch(() => {});
  }, []);

  const close = () => {
    if (ann) localStorage.setItem(STORAGE_KEY, hashOf(ann));
    setOpen(false);
  };

  return (
    <AnimatePresence>
      {open && ann && (
        <motion.div
          data-testid="announcement-popup"
          role="dialog"
          aria-label={ann.title}
          initial={{ opacity: 0, y: 32, scale: 0.96 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.97 }}
          transition={{ duration: 0.7, ease: EASE }}
          className="fixed bottom-6 right-6 left-6 z-[80] max-w-sm rounded-[1.75rem] border border-clay/25 bg-shell p-8 shadow-[0_30px_80px_-25px_rgba(36,56,47,0.45)] sm:left-auto"
        >
          <button
            onClick={close}
            data-testid="announcement-close"
            aria-label="Fermer le message"
            className="absolute right-5 top-5 flex h-8 w-8 items-center justify-center rounded-full border border-linen text-smoke transition-colors duration-300 hover:border-clay hover:text-clay"
          >
            <X className="h-4 w-4" />
          </button>
          <p className="font-hand text-3xl text-clay">{ann.title}</p>
          <p className="mt-4 text-sm leading-relaxed text-smoke">{ann.message}</p>
          {ann.cta_label && ann.cta_url && (
            <a
              href={ann.cta_url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="announcement-cta"
              className="group mt-6 inline-flex items-center gap-2 rounded-full bg-clay px-6 py-3 text-xs font-medium uppercase tracking-[0.15em] text-cream transition-colors duration-300 hover:bg-charcoal"
            >
              {ann.cta_label}
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
